import React from "react";
import { Star, CircleCheck } from "lucide-react";

const REVIEWS = [
    {
        name: "Dr. M. Usman",
        text: "Fastest delivery! Received my bottle in 2 days in Faisalabad. Packaging is premium and the dropper works smoothly. Highly recommended.",
    },
    {
        name: "Mariam Ali",
        text: "I used expensive imported oils before, but Dermalist Rosemary Serum is far better and non-sticky. My hair feels much fuller.",
    },
    {
        name: "Bilal Hassan",
        text: "Cash on delivery was smooth. The courier handed me the box, I paid. Honestly a steal at 2,499 PKR.",
    },
];

const QUOTES = [
    {
        name: "Ayesha Siddiqui",
        city: "Lahore",
        text: "My post-partum hair fall stopped completely within 3 weeks of daily application.",
    },
    {
        name: "Saad Rehman",
        city: "Karachi",
        text: "Best lightweight formula. Doesn't make my scalp greasy at all.",
    },
    {
        name: "Sana Fatima",
        city: "Islamabad",
        text: "100% original. The PCSIR certification gave me full peace of mind.",
    },
];

export default function ReviewsSection() {
    return (
        <section
            data-testid="reviews-section"
            id="reviews"
            className="py-16 sm:py-20 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl mb-12">
                    <span className="text-gold-600 font-bold text-xs uppercase tracking-[0.25em] block mb-3">
                        Verified Experience
                    </span>
                    <h2 className="font-serif text-4xl sm:text-5xl font-bold text-forest-800 leading-tight">
                        Loved by thousands{" "}
                        <span className="italic">across Pakistan</span>.
                    </h2>
                    <p className="text-forest-900/70 mt-4 text-base sm:text-lg">
                        Real customer stories from people who finally found a
                        serum that works.
                    </p>
                </div>

                {/* Short highlight quotes */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
                    {QUOTES.map((q, i) => (
                        <div
                            key={i}
                            data-testid={`quote-card-${i}`}
                            className="bg-forest-900 rounded-3xl p-6 border border-gold-500/20 text-white relative overflow-hidden"
                        >
                            <div className="flex text-gold-400 mb-3">
                                {[...Array(5)].map((_, k) => (
                                    <Star
                                        key={k}
                                        className="w-4 h-4 fill-gold-400"
                                    />
                                ))}
                            </div>
                            <p className="text-sm text-cream/90 leading-relaxed mb-5">
                                "{q.text}"
                            </p>
                            <div className="flex items-center justify-between pt-4 border-t border-white/10">
                                <span className="font-bold text-white text-sm">
                                    {q.name}
                                </span>
                                <span className="text-[11px] bg-gold-500/15 text-gold-400 px-2 py-0.5 rounded font-semibold">
                                    {q.city}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Written reviews */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    {REVIEWS.map((r, i) => (
                        <div
                            key={i}
                            data-testid={`review-card-${i}`}
                            className="bg-cream p-6 rounded-3xl border border-forest-100 shadow-sm hover:shadow-md transition-all"
                        >
                            <div className="flex text-gold-500 mb-3">
                                {[...Array(5)].map((_, k) => (
                                    <Star
                                        key={k}
                                        className="w-4 h-4 fill-gold-500"
                                    />
                                ))}
                            </div>
                            <p className="text-sm text-forest-900/80 leading-relaxed mb-4">
                                "{r.text}"
                            </p>
                            <div className="flex items-center justify-between text-xs pt-3 border-t border-forest-100">
                                <span className="font-bold text-forest-800">
                                    {r.name}
                                </span>
                                <span className="text-forest-700 font-medium flex items-center gap-1">
                                    <CircleCheck className="w-3.5 h-3.5" />
                                    Verified Buyer
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
